module.exports = __webpack_public_path__ + "img/control-center.6ad24a52.png";